import React, { useState, useEffect } from "react";
import eventData from "../../utils/data/homepage.json";
import Buttons from "../../components/Elements/Buttons";

const Events = () => {
  const { title, description } = eventData.events;
  
  // Target date: November 21, 2025 at 9:00 AM
  const targetDate = new Date("2025-11-21T09:00:00").getTime();
  
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
        setIsAnimating(true);
        
        // Reset animation after a short delay
        setTimeout(() => setIsAnimating(false), 300);
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    // Calculate immediately
    calculateTimeLeft();

    // Update every second
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  const countdownData = [
    { label: "Days", value: timeLeft.days.toString().padStart(2, '0') },
    { label: "Hours", value: timeLeft.hours.toString().padStart(2, '0') },
    { label: "Minutes", value: timeLeft.minutes.toString().padStart(2, '0') },
    { label: "Seconds", value: timeLeft.seconds.toString().padStart(2, '0') },
  ];

  return (
    <div className="relative">
      <style jsx>{`
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }
        
        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
          40% { transform: translateY(-10px); }
          60% { transform: translateY(-5px); }
        }
        
        @keyframes glow {
          0% { box-shadow: 0 0 5px rgba(255, 255, 255, 0.3); }
          50% { box-shadow: 0 0 20px rgba(255, 255, 255, 0.8); }
          100% { box-shadow: 0 0 5px rgba(255, 255, 255, 0.3); }
        }
        
        .countdown-animate {
          animation: pulse 0.3s ease-in-out, glow 0.6s ease-in-out;
        }
      `}</style>
      {/* Background Image */}
      <img
        className="w-full h-[762px] max-lg:h-[60vh] max-lg:w-auto object-cover object-top opacity-140"
        src="/assets/home-event-bg.jpg"
        alt="Events Background"
      />

      {/* Overlay Layer */}
      <div
        className="absolute inset-0 bg-[#600924]/80 "
        // style={{ backgroundColor: "rgba(74, 4, 25, 0.5) "}}
      ></div>
      {/* 
        #67142D1A → equivalent to rgba(103, 20, 45, 0.1)
        (1A = 10% opacity in hex)
      */}

      {/* Optional Content */}
      <div className="absolute inset-0  flex flex-col items-center text-center px-4  mt-28 max-lg:mt-10 max-md:mt-5 ">
        <p className="text-white font-source-serif-4 text-4xl max-lg:text-2xl font-semibold">
          {title}
        </p>
        <p className="text-white font-inter text-[20px]  mt-4 w-[800px] max-lg:w-[90%] mx-auto ">
          {description}
        </p>

        <div className="mt-56 max-lg:mt-10 max-md:mt-5 flex flex-col items-center">
          <div className="flex gap-8 max-lg:gap-4">
            {countdownData.map((item, idx) => (
              <div
                key={idx}
                className="flex flex-col items-center font-source-serif-4 justify-center text-[#67142D]"
              >
                <div 
                  className={`w-[120px] h-[100px] max-lg:w-[60px] max-lg:h-[60px] font-bold bg-white flex justify-center items-center rounded-md shadow-lg text-6xl max-lg:text-3xl transition-all duration-300 ease-in-out ${
                    isAnimating ? 'countdown-animate' : ''
                  }`}
                >
                  <span 
                    className={`transition-all duration-300 ${
                      isAnimating ? 'text-[#67142D] transform scale-110' : 'text-[#67142D]'
                    }`}
                  >
                    {item.value}
                  </span>
                </div>
                <span className="text-white lg:text-[20px] mt-2 uppercase tracking-wider transition-all duration-300">
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="flex gap-6 mt-10 max-lg:gap-3">
          <Buttons
            color="white"
            textColor=""
            buttonText="Join the Event"
          />
          {/* <Buttons
            color="transparent"
            className="border-[1px] bolid-soild border-#fff"
            textColor="white"
            buttonText="Learn More"
          /> */}
        </div>
      </div>
    </div>
  );
};

export default Events;
